import PreviewPdfComponent from "./pdf-preview.vue";
import ViewComponent from "./view.vue";
import FormComponent from "./form.vue";

export {
    PreviewPdfComponent,
    ViewComponent,
    FormComponent
}